export class AddWorkOrderResultDto {
    workOrderId: number;
    communityId: number;
}
